import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { Section } from 'src/screens/account/header/Section'
import { Status as UserStatus } from 'src/system/user/Status'

export function Status() {
  const { t } = useTranslation()
  return (
    <Section title={t('account:header:status')}>
      <StyledStatus />
    </Section>
  )
}

const StyledStatus = styled(UserStatus)`
  height: 16px;
`
